var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeakerImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 844,
    height: 117,
    viewBox: "0 0 844 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.734375,
    y: 54.8477,
    width: 6.96312,
    height: 8.21418,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 18.1406,
    y: 54.8477,
    width: 6.96312,
    height: 8.21418,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 35.5508,
    y: 52.1094,
    width: 6.96312,
    height: 13.6903,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 52.957,
    y: 52.1094,
    width: 6.96312,
    height: 13.6903,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 70.3672,
    y: 52.1094,
    width: 6.96312,
    height: 13.6903,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 87.7734,
    y: 52.1094,
    width: 6.96312,
    height: 13.6903,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 105.18,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 122.59,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 139.996,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 157.406,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 174.812,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 192.219,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 209.629,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 227.035,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 244.445,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 261.852,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 279.258,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 296.668,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 314.074,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 331.484,
    y: 49.2852,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 348.891,
    y: 44.4492,
    width: 6.96312,
    height: 29.0036,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 366.297,
    y: 37.0469,
    width: 6.96312,
    height: 43.809,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 383.707,
    y: 29.7461,
    width: 6.96312,
    height: 58.412,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 401.113,
    y: 15.4453,
    width: 6.96312,
    height: 87.0107,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 418.523,
    y: 0.945312,
    width: 6.96312,
    height: 116.014,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 435.93,
    y: 29.625,
    width: 6.96312,
    height: 58.6586,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 453.336,
    y: 29.7461,
    width: 6.96312,
    height: 58.412,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 470.746,
    y: 37.0469,
    width: 6.96312,
    height: 43.809,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 488.152,
    y: 39.6172,
    width: 6.96312,
    height: 38.6714,
    rx: 3.48156,
    fill: "#224B99"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 6.96312,
    height: 8.21418,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 843.273 54.8477)",
    fill: "#224B99"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 6.96312,
    height: 8.21418,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 825.867 54.8477)",
    fill: "#224B99"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 6.96312,
    height: 13.6903,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 808.457 52.1094)",
    fill: "#224B99"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 6.96312,
    height: 13.6903,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 791.051 52.1094)",
    fill: "#224B99"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 6.96312,
    height: 13.6903,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 773.641 52.1094)",
    fill: "#224B99"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 6.96312,
    height: 13.6903,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 756.234 52.1094)",
    fill: "#224B99"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 738.828 49.2852)",
    fill: "#224B99"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 721.418 49.2852)",
    fill: "#224B99"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 704.012 49.2852)",
    fill: "#224B99"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 686.602 49.2852)",
    fill: "#224B99"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 669.195 49.2852)",
    fill: "#224B99"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 651.789 49.2852)",
    fill: "#224B99"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 634.379 49.2852)",
    fill: "#224B99"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 616.973 49.2852)",
    fill: "#224B99"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 599.562 49.2852)",
    fill: "#224B99"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 582.156 49.2852)",
    fill: "#224B99"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 564.75 49.2852)",
    fill: "#224B99"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 547.34 49.2852)",
    fill: "#224B99"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 529.934 49.2852)",
    fill: "#224B99"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    width: 6.96312,
    height: 19.3357,
    rx: 3.48156,
    transform: "matrix(-1 0 0 1 512.523 49.2852)",
    fill: "#224B99"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerImg);
export default __webpack_public_path__ + "static/media/speakerImg.fc53f01a625b75831c73a08f5b9e5848.svg";
export { ForwardRef as ReactComponent };